// GET_ADMIN
export const GET_ADMIN_LIST = "GET_ADMIN_LIST";
export const GET_ADMIN_BY_ID = "GET_ADMIN_BY_ID";
export const GET_ADMIN_ROLES_BY_ID = "GET_ADMIN_ROLES_BY_ID";
export const GET_ROLE_HISTORY = "GET_ROLE_HISTORY";

// GET_CATEGARY
export const GET_CATEGARY = "GET_CATEGARY";
export const GET_CATEGARY_PRODUCT = "GET_CATEGARY_PRODUCT";
export const GET_CATEGARY_BY_ID = "GET_CATEGARY_BY_ID";

// GET_SUBCATEGORY
export const GET_SUBCATEGORY = "GET_SUBCATEGORY";
export const GET_SUBCATEGORY_BY_ID = "GET_SUBCATEGORY_BY_ID";

// GET_BUSINESS
export const GET_BUSINESS = "GET_BUSINESS";
export const GET_BUSINESS_BY_ID = "GET_BUSINESS_BY_ID";

// GET_DRIVER
export const GET_DRIVER = "GET_DRIVER";
export const GET_DRIVER_BY_ID = "GET_DRIVER_BY_ID";

// GET_USER
export const GET_USER = "GET_USER";
export const GET_USER_BY_ID = "GET_USER_BY_ID";

// GET_PROFESSIONAL
export const GET_PROFESSIONAL = "GET_PROFESSIONAL";
export const GET_PROFESSIONAL_BY_ID = "GET_PROFESSIONAL_BY_ID";

// GET_OFFER
export const GET_OFFER = "GET_OFFER";
export const GET_OFFER_BY_ID = "GET_OFFER_BY_ID";

// GET_TERMSCONDITION
export const GET_TERMSCONDITION = "GET_TERMSCONDITION";
export const GET_TERMSCONDITION_BY_ID = "GET_TERMSCONDITION_BY_ID";

// GET_SETTING
export const GET_SETTING = "GET_SETTING";


// // get_product
// export const GET_PRODUCT = "GET_PRODUCT";
// export const GET_PRODUCT_BY_ID = "GET_PRODUCT_BY_ID";